import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M8 13h8a4 4 0 1 1 -8 0z","key":"svg-1"}]]

const IconBrandFunimation = createReactComponent('outline', 'brand-funimation', 'BrandFunimation', __iconNode);

export default IconBrandFunimation;